import { toast, type ExternalToast } from 'sonner';
import type { ReactNode } from 'react';

export * from './Notification';

export type NotificationOptions = ExternalToast;

export function useNotification() {
  // without re-defining the interface storybook has trouble to build the declaration file
  return {
    info: (message: ReactNode, options?: NotificationOptions) =>
      toast(message, options),
    success: (message: ReactNode, options?: NotificationOptions) =>
      toast.success(message, options),
    error: (message: ReactNode, options?: NotificationOptions) =>
      toast.error(message, options),
    warning: (message: ReactNode, options?: NotificationOptions) =>
      toast.warning(message, options),
    message: (message: ReactNode, options?: NotificationOptions) =>
      toast.message(message, options),
    loading: (message: ReactNode, options?: NotificationOptions) =>
      toast.loading(message, options),
    dismiss: (id?: string | number) => toast.dismiss(id),
  };
}
